import { ReactElement, ReactNode } from 'react';
import {
  Controller,
  Control,
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister,
} from 'react-hook-form';
import get from 'lodash/get';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  register?: UseFormRegister<TFieldValues>;
  size?: FormControlProps['size'];
  name: string;
  label?: string;
  centerIcon?: ReactNode;
  disabled?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  cb?: () => void;
}

const ToggleComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  register,
  size = 'medium',
  name,
  label = '',
  disabled = false,
  centerIcon,
  labelPlacement,
  cb,
}: IProps<TFieldValues>): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  const props = register?.(name as Path<TFieldValues>) || {};

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <FormControl variant="outlined">
          <FormControlLabel
            control={
              <>
                <Switch
                  checked={value as boolean}
                  name={name}
                  color="primary"
                  size={size}
                  onChange={e => {
                    onChange(e);
                    cb?.();
                  }}
                  {...(props || {})}
                />
                {centerIcon}
              </>
            }
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
          />
          {error && <FormHelperText error>{error.toString()}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default ToggleComponent;
